import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollApp = () => {
    const element = document.querySelector('#samples-app-scrollable') ?? window;

    const scrollApp = useCallback(
        (x: number, y: number) => {
            element && element.scrollTo(x, y);
        },
        [element],
    );

    return scrollApp;
};

const ScrollToTop = () => {
    const { pathname } = useLocation();

    const scrollApp = useScrollApp();

    useEffect(() => {
        scrollApp(0, 0);
    }, [pathname, scrollApp]);

    return null;
};

export default ScrollToTop;
